import { useNavigate } from 'react-router-dom'


const GoToBack = ({ url, className }) => {
    const navigate = useNavigate()


    return (
        <button type='button' className={`GoToBack ${className !== '' ? ' ' + className : ''}`} onClick={() => navigate(url)}>
            {/* <i className="bi bi-arrow-return-left"></i> */}
            <i className="bi bi-chevron-double-left GoToBack__Icon"></i>
            <span className='GoToBack__Text'>Regresar</span>
        </button>
    )
}

export { GoToBack };